
export class FilterEditorService {
  constructor($q, FilterEditorModalService, FilterCardEditorModalService, FiltersService, CurrentModelService, RouterService, CurrentFilterService) {
    this.$q = $q;
    this.FilterEditorModalService = FilterEditorModalService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.RouterService = RouterService;
    this.CurrentFilterService = CurrentFilterService;
  }

  editModal({filter, asNew, selectFilter}) {
    return this.$q.resolve()
      .then(() => {
        if (filter.isDimensionCard) {
          return this.FilterCardEditorModalService.open(
            this.CurrentModelService.model,
            filter,
            asNew,
          );
        }
        return this.FilterEditorModalService.open(
          this.CurrentModelService.model,
          filter,
          asNew,
        );
      })
      .then(filterEdit => {
        if (filterEdit === null) {
          this.onDeleteFilter(filter);
          return;
        }
        filterEdit._changed = false;
        if (asNew || !filter.id) {
          this.FiltersService.filters.push(filterEdit);
        } else {
          let originalFilter = this.FiltersService.findById(filterEdit.id);
          Object.assign(originalFilter, filterEdit);
        }
        Object.assign(filter, filterEdit);
        if (selectFilter) {
          this.RouterService.selectFilter(filterEdit.id);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  saveFilter(asNew) {
    let filter = this.CurrentFilterService.filter;
    if (!asNew && filter.id) {
      this.FiltersService.save(filter)
        .then(() => this.RouterService.filterChanged());
      return;
    }
    this.editModal({filter, asNew, selectFilter: true});
  }

  onDeleteFilter(filter) {
    this.FiltersService.onDeleteFilter(filter);
    this.RouterService.onDeleteFilter();
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor.service.js